// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__P4hSW","title":"styles_title__xp-O7","overviewTable":"styles_overviewTable__XSKPE","smallCol":"styles_smallCol__ej0PS"};